// extracted by mini-css-extract-plugin
export default {"designCard":"DesignEditorElement_designCard__Ezp7z","designCardHeader":"DesignEditorElement_designCardHeader__4WKQf","designImage":"DesignEditorElement_designImage__pg1s4"};